export default function NotFound() {
    return (
        <div>
            404 - Page Not Found
        </div>
    )
}
